// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CheckboxTokens } from './type';

const checkboxTokens: CheckboxTokens = {
  checkboxIconSize: 'Font-14',
  checkboxIconBorderColor: 'Neutral-border-2',
  checkboxIconBorderRadius: 'Radius-lesser',
  checkboxIconBorderWidth: 'Border-1',
  checkboxIconBackgroundColor: 'Neutral-fill-1',
  checkboxIconColor: 'transparent',
  checkboxIconDisabledBorderColor: 'Neutral-border-1',
  checkboxIconDisabledBackgroundColor: 'Neutral-fill-2',
  checkboxIconDisabledColor: 'transparent',
  checkboxIconHoverBackgroundColor: 'Neutral-fill-1',
  checkboxIconHoverColor: 'transparent',
  checkboxIconCheckedBorderColor: 'Brand-6',
  checkboxIconCheckedBackgroundColor: 'Brand-6',
  checkboxIconCheckedColor: 'Neutral-fill-1',
  checkboxIconCheckedDisabledBorderColor: 'Brand-3',
  checkboxIconCheckedDisabledBackgroundColor: 'Brand-3',
  checkboxIconCheckedDisabledColor: 'Neutral-fill-1',
  checkboxIconGap: 'Spacing-8',
  checkboxIconCircleFill: 'Neutral-fill-2',
  checkboxIconCircleDark: 'Neutral-fill-3',
  checkboxFontWeight: 'Weight-regular',
  checkboxLabelFontColor: 'Neutral-text-5',
  checkboxLabelFontSize: 'Font-14',
  checkboxLabelDisabledFontColor: 'Neutral-text-2',
  checkboxIndicatorMarginTop: 'Spacing-4',
  checkboxGap: 'Spacing-24',
  checkboxBlockGap: 'Spacing-12',
  checkboxSmallIconSize: 'Font-12',
  checkboxSmallLabelFontSize: 'Font-12',
  checkboxLargeIconSize: 'Font-16',
  checkboxLargeLabelFontSize: 'Font-16',
};

export default checkboxTokens;
